import { render } from "./CollapsableCore.vue?vue&type=template&id=ee477200&scoped=true"
import script from "./CollapsableCore.vue?vue&type=script&lang=js"
export * from "./CollapsableCore.vue?vue&type=script&lang=js"

import "./CollapsableCore.vue?vue&type=style&index=0&id=ee477200&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee477200"]])

export default __exports__